module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/empty.ee3c1c7c21.png";